import ModalInventoryDetails from './ModalInventoryDetails'

export default ModalInventoryDetails
